import { AxiosInstance } from 'axios'
import { ApiResult, idItem } from '../server.api'

export default class SanteOptionApi {
  instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(input: SanteOptionCreate): Promise<ApiResult<idItem>> {
    return this.instance.post('/SanteOption', input)
  }

  async update(input: SanteOptionUpdate): Promise<ApiResult<idItem>> {
    return this.instance.put('/SanteOption', input)
  }

  async delete(id: number): Promise<ApiResult<idItem>> {
    return this.instance.delete('/SanteOption', { params: { id } })
  }
}

type SanteOptionCreationMode = 'Empty' | 'CopyFromBase' | 'CopyFromOption'

type SanteOptionCreate = {
  accordId: number
  name: string
  numero: number
  isBaseComplement: boolean
  includesSecuriteSociale: boolean | null
  creationMode: SanteOptionCreationMode
  sourceOptionId: number | null
}

type SanteOptionUpdate = SanteOptionCreate & {
  id: number
}

export { SanteOptionCreate, SanteOptionCreationMode, SanteOptionUpdate }
